<div [attr.class]="'booking-widget ' + (classList | addClassList: { mainClass: 'booking-widget--' })">
  <div [attr.class]="'booking-widget__inner ' + (classList | addClassList: { mainClass: 'booking-widget__inner--' })">
    <!-- widget at unit group details page -->
    <ng-container *ngIf="widgetSpecifiedType === widgetType.pdp">
      <div [attr.class]="'booking-widget__form form ' + (classList ? 'booking-widget__form--' + classList : '')">
        <ng-container *ngTemplateOutlet="bookingParamsFields" />
      </div>
    </ng-container>
    <!-- /widget at unit group details page -->

    <!-- widget at checkout page -->
    <ng-container *ngIf="widgetSpecifiedType === widgetType.checkout">
      <ng-container
        *ngTemplateOutlet="
          bookingHeading;
          context: { classList: 'inner inner-listings', isShowImage: true, bwImages: bwImages }
        "
      />
      <div class="booking-widget__form form">
        <ng-container *ngTemplateOutlet="bookingParamsFields" />
        <ng-container *ngTemplateOutlet="bookingInfoSummary" />
      </div>
    </ng-container>
    <!-- /widget at checkout page -->

    <!-- widget at checkout page (mobile version 3rd step) -->
    <ng-container *ngIf="widgetSpecifiedType === widgetType.checkoutDetails">
      <ng-container *ngTemplateOutlet="bookingHeading; context: { classList: 'checkout-details' }" />
      <div class="booking-widget__form form" [ngClass]="{ hidden: hiddenContent }">
        <app-booking-checkout-details [selectedDatesLabel]="selectedDatesLabel" [guests]="adults" />
        <ng-container *ngTemplateOutlet="bookingInfoSummary; context: { classList: 'unit-details' }" />
      </div>
    </ng-container>
    <!-- /widget at checkout page (mobile version 3rd step) -->
  </div>
  <ng-container
    *ngIf="
      widgetSpecifiedType !== widgetType.checkoutDetails &&
      widgetSpecifiedType !== widgetType.pdp &&
      allOffers?.length > 0
    "
  >
    <p class="booking-widget__info-text">
      {{ 'checkout.payment.price-includes-vat' | translate }}
    </p>
  </ng-container>
</div>

<ng-template #bookingHeading let-classList="classList" let-isShowImage="isShowImage" let-bwImages="bwImages">
  <app-booking-heading
    [classList]="classList"
    [dataFetched]="dataFetched"
    [name]="name"
    [streetAddress]="streetAddress"
    [isShowImage]="isShowImage"
    [bwImages]="bwImages"
    (isCollapsed)="openDetails($event)"
  />
</ng-template>
<ng-template #bookingParamsFields>
  <ng-container *ngIf="widgetSpecifiedType === widgetType.checkout">
    <ng-container *ngIf="dataFetched">
      <div class="widget-header">
        <h6 class="widget-header__title">{{ 'widget-your-trip' | translate }}</h6>
        <button
          sparkButton
          background="outline"
          type="button"
          class="widget-header__btn"
          (click)="toggleBookingWidget()"
        >
          {{ 'profile.edit' | translate }}
          <i class="fa-light fa-pen-to-square widget-header__icon"></i>
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="!isOpened && dataFetched">
      <div class="widget-header__info">
        <div class="widget-header__info-dates">
          <div class="widget-header__info-dates-item">
            <div>{{ 'calendar-check-in' | translate }}</div>
            <div class="widget-header__info-date">{{ arrivalDate | formatDate: 'dd. LLL yyyy' : currentLang }}</div>
          </div>
          <div class="widget-header__info-dates-item">
            <div>{{ 'calendar-check-out' | translate }}</div>
            <div class="widget-header__info-date">{{ departureDate | formatDate: 'dd. LLL yyyy' : currentLang }}</div>
          </div>
        </div>
        <div class="widget-header__info-guest">
          <span class="widget-header__info-guest-item">{{ 'booking-widget-guests' | translate }}</span>
          <span class="widget-header__info-guest-item">
            {{ adults | pluralize: 'adult' : 'adults'
            }}<ng-container *ngIf="childrenAgesArr.length">{{ ',' }}</ng-container>
            <ng-container *ngIf="childrenAgesArr.length">
              {{ childrenAgesArr.length | pluralize: 'child' : 'children' }}
            </ng-container>
          </span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!dataFetched">
      <app-loading-placeholder [type]="placeholderTypes.widgetEdit" />
    </ng-container>
  </ng-container>
  <app-widget-params
    *ngIf="widgetSpecifiedType === widgetType.checkout ? isOpened : true"
    [openGuestPickerModalOnMobile]="openGuestPickerModalOnMobile"
    [cityId]="city"
    [propertyId]="propertyId"
    [unitGroupId]="unitGroupId"
    [checkin]="checkin"
    [checkout]="checkout"
    [dataFetched]="dataFetched"
    [rooms]="rooms"
    [adults]="adults"
    [childrenAges]="childrenAges"
    [isFetching]="isFetching"
    [updateGuestWithoutRequest]="updateGuestWithoutRequest"
    [selectedDatesLabel]="selectedDatesLabel"
    [selectedDates]="selectedDates"
    [widgetSpecifiedType]="widgetSpecifiedType"
    [classList]="classList"
    [isEmptyDates]="isEmptyDates"
    [currentLang]="currentLang"
    [isExtension]="isExtension"
    [readOnly]="readOnly"
    [calendarType]="calendarType"
    [guestCtaText]="guestCtaText"
    (bookedDates)="processBookedDates($event)"
    (guestsData)="updateGuestsData($event)"
    (widgetPickersOpeningStatus)="onGuestDropdownStatus($event)"
    (datePickersOpeningStatus)="onDatePickerStatus($event)"
  />
</ng-template>
<ng-template #bookingInfoSummary let-classList="classList">
  <app-booking-total-info
    [classList]="classList"
    [dataFetched]="dataFetched"
    [confirmationDataLoaded]="confirmationDataLoaded"
    [isOfferExist]="allOffers?.length > 0"
    [daysCount]="daysCount"
    [confirmationTotal]="confirmationTotal"
    [currency]="currency"
    [applicableCosts]="applicableCosts"
    [ratePlan]="ratePlan"
    [isExtension]="isExtension"
  />
</ng-template>
<!--<ng-template #bookingRefund>-->
<!--  <app-booking-refund *ngIf="allOffers?.length" [ratePlan]="ratePlan?.cancellationPolicyCode"></app-booking-refund>-->
<!--</ng-template>-->
<ng-template #bookingBookBtn>
  <ng-container *ngIf="dataFetched">
    <button
      *ngIf="!(isMobile === true)"
      sparkButton
      type="submit"
      id="qa_booking-widget-button"
      tabindex="13"
      [disabled]="!allOffers?.length || isFetching || isDisabled"
      [ngClass]="{ sending_request: bookingProperty }"
      (click)="bookProperty()"
    >
      <span *ngIf="!isFetching">{{ btnText | translate }}</span>
      <app-loading-indicator *ngIf="isFetching" />
    </button>
  </ng-container>
  <div *ngIf="!dataFetched && !isMobile" class="placeholder-text placeholder-text--button"></div>
</ng-template>
